import { contracts } from './contracts';

export const es = { contracts };
